/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';

export interface IAccountProfileEditLoadingMessage {
    className: string;
    message: string;
}

const AccountProfileEditLoadingMessage: React.FC<IAccountProfileEditLoadingMessage> = ({ className, message }) => (
    <div className={`${className}__loading-message`} >
        {message}
    </div>
);

export default AccountProfileEditLoadingMessage;
